import React from 'react';
import { collection, query } from 'firebase/firestore';
import { Box, Container,Typography,Table,TableRow,TableCell,TableHead,Paper,TableBody,withStyles, Theme, createStyles } from '@material-ui/core';
import { useFirestoreCollectionData,useFirestore } from 'reactfire';
import Page from 'src/components/Page';
import { useAuthContext } from 'src/context/AuthContext';
import * as _ from 'lodash';
import LoadingView from 'src/views/auth/LoadingView';

import {UserType} from 'src/views/user-management/model';

interface textCountType {
  id:string,
  members:any,
  teamCount:any,
  textCount:number
}
import moment from 'moment';
export const ResultTable = () => {
  type IType =
    | 'string'
    | 'boolean'
    | 'numeric'
    | 'date'
    | 'datetime'
    | 'time'
    | 'currency';
  const string: IType = 'string';

  const {user} = useAuthContext();


  const db = useFirestore();
  const usersQuery = query(collection(db, 'users'));
  const { status:userDataStatus,data:usersData } = useFirestoreCollectionData(usersQuery, {
    idField: 'id', // this field will be added to the object created from each document
  });
  const groupsResultQuery= query(collection(db, 'reportCounter',moment().format('MM-DD-YYYY'),'groups'));
  
  const { status:textCounterStatus,data: textCounter} = useFirestoreCollectionData(groupsResultQuery,{
    idField: 'id', // this field will be added to the object created from each document
  });
  if(userDataStatus==='loading'||textCounterStatus==='loading'){
    return <LoadingView/>;
  }

  console.log('textCounter',textCounter);


  let groups:number[] = [];
  switch(user.role) {
  case 'admin':
    // code block
    groups = [user.group,..._.sortBy(_.uniq(_.map(usersData, 'group'))).filter(x=>x!==user.group)];
    break;
  case 'gyjn':
    // code block
    groups = [user.group,..._.sortBy(_.uniq(_.map(usersData, 'group'))).filter(x=>x!==user.group)];
    break;

  case 'sgyjn':
    // code block
    groups = [user.group,..._.sortBy(_.uniq(_.map(usersData, 'group'))).filter(x=>x!==user.group)];
    break;
  default:
    groups = [user.group];
      // code block
  }

  const usersDataOrderByGroup = _.uniqBy(_.orderBy(usersData, ['group', 'team','order'], ['asc', 'asc','asc']),'name') as UserType[];
  
  
  return (
    <Page title="Ev Results">
      <Box p={3}>
        <Container>
          {groups.map((group,key)=>(
            <Box pb={3} key={key}>     
              <Typography gutterBottom variant="h3">
              Group {group} result:
              </Typography>
        
              
              <GroupTextResultTable textCounter={textCounter} groupNum={group} groupData={usersDataOrderByGroup.filter(user=>user.group===group)}/>
            </Box>
          ))}

        </Container>
      </Box>
    </Page>
  );
};


interface GroupTextResultTableType {
  groupData:UserType[],
  groupNum:number,
  textCounter:any,
}

const GroupTextResultTable:React.VFC<GroupTextResultTableType> = ({groupData,groupNum,textCounter})=>{
  const structuredData = _.groupBy(groupData.filter(user=>user.group===groupNum),'team');
  const textCountResult = textCounter.find((result:textCountType)=>result.id===groupNum+'');

  return (
    <Paper>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell></TableCell> 
            <TableCell>Member</TableCell>
            <TableCell>Online Texting</TableCell>
            <TableCell>Offline Fishing</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(structuredData).map((teamNumber)=>(
            <>
              <TableRow >
                <TeamLeftCell style={{ width: 0 }} rowSpan={Object.keys(structuredData[teamNumber]).length+1}>T{teamNumber}</TeamLeftCell>
              </TableRow>
              {structuredData[teamNumber].map((member,key)=>{
                return (
                  <TableRow key={key}>
                    <TableCell>{member.name&&member.name.split(' / ')[0]} {userRole(member.role)}</TableCell>
                    <TableCell>{memberFishingResult(textCountResult,member.name)}</TableCell>
                    <TableCell>{memberOfflineFishingResult(textCountResult,member.name)}</TableCell>
                  </TableRow>
                );
              })}
      
              <TeamTotalRow >
                <TeamTotalCell></TeamTotalCell>
                <TeamTotalCell>Team {teamNumber} Total</TeamTotalCell>
                <TeamTotalCell>{teamFishingResult(textCountResult,teamNumber)}</TeamTotalCell>
                <TeamTotalCell>{teamOfflineFishingResult(textCountResult,teamNumber)}</TeamTotalCell>
              </TeamTotalRow>

            </>
          ))}
          <GroupTotalRow >
            <TeamTotalCell></TeamTotalCell>
            <TeamTotalCell>Group {groupNum} Total</TeamTotalCell>
            <TeamTotalCell>{textCountResult===undefined?0:textCountResult?.textCount??0}</TeamTotalCell>
            <TeamTotalCell>{textCountResult===undefined?0:textCountResult?.offlineFishingCount??0}</TeamTotalCell>
          </GroupTotalRow>
        </TableBody>
      </Table>
    </Paper>
  );
  // console.log('.groupBy',_.groupBy(usersDataOrderByGroup.filter(user=>user.group===1),'team'));

};

const memberFishingResult = (textCountResult:any,name:string)=>{
  
  if(textCountResult===undefined){
    return 0;
  }
  else if(textCountResult.members){
    const userResult= Object.keys(textCountResult.members).map((userId)=>{
      return textCountResult.members[userId];
    }).find(user=>user.name===name);
    return userResult!==undefined?userResult?.textCount??0:0;
  }
  else{
    return 0;
  }
};

const memberOfflineFishingResult = (textCountResult:any,name:string)=>{
  
  if(textCountResult===undefined){
    return 0;
  }
  else if(textCountResult.members){
    const userResult= Object.keys(textCountResult.members).map((userId)=>{
      return textCountResult.members[userId];
    }).find(user=>user.name===name);
    return userResult!==undefined?userResult.offlineFishingCount:0;
  }
  else{
    return 0;
  }
};


const teamFishingResult = (textCountResult:any,teamNum:string)=>{

  if(textCountResult===undefined){
    return 0;
  }
  else{
    const result =textCountResult.teamCount[teamNum]?.textCount;
    return result!==undefined? result:0;
  }
};


const teamOfflineFishingResult = (textCountResult:any,teamNum:string)=>{

  if(textCountResult===undefined){
    return 0;
  }
  else{
    const result =textCountResult.teamCount[teamNum]?.offlineFishingCount;
    return result!==undefined? result:0;
  }
};

//https://codesandbox.io/s/hc0fw?file=/src/App.tsx

const TeamTotalRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: 'rgba(5, 217, 251, 8%)',

    },
  }),
)(TableRow);

const GroupTotalRow= withStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: 'rgba(112, 251, 5, 8%)',

    },
  }),
)(TableRow);


const TeamTotalCell = withStyles((theme: Theme) =>
  createStyles({
    root: {
      fontWeight:500

    },
  }),
)(TableCell);



const TeamLeftCell = withStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.action.hover,
      padding:'0px !important',
      textAlign:'center'
    },
  }),
)(TableCell);



const userRole = (role:string) =>{
  if(role ==='gyjn'|| role ==='sgyjn'|| role==='tjn'){
    return `(${_.upperCase(role)})`;
  }
  return '';
}; 